import React, {useEffect, useState} from 'react'
import axios from "axios";
import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";


const useStyles = makeStyles((theme) => ({
    formControl: {
      marginRight: theme.spacing(3),
    
      minWidth: 'auto',
    
    },
    select:{
        
        minWidth: theme.spacing(7)
    },
    
  }));

const WhatsappSelect = (props) => {
    const {values, handleChange} = props
    const [paises, setPaises] = useState({})
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        // axios.get('https://restcountries.eu/rest/v2/all').then(response => {
        //     setPaises(response.data);
        //     setLoading(false);
        // });
        setPaises(JSON.parse(sessionStorage.getItem('countrys')).data);
        setLoading(false);
        // console.log(paises[0].nombre);

    }, [])
    const classes = useStyles();
    return (
        <>
            <FormControl className={classes.formControl} fullWidth={props.fullWidth ? true : false} required>


                <InputLabel
                    id='country-label'
                >
                    País
                </InputLabel>
                <Select
                    required
                    labelId='country-label'
                    classes={{ select: (classes.select) }}
                    value={values.country}
                    id='country'
                    name="country"
                    onChange={handleChange}
                >
                    
                    {
                        (!loading) &&
                        paises.map(pais => {
                            return (
                                <MenuItem key={pais.nombre} value={`${pais.nombre}(+${pais.phone_code})`}>
                                    {pais.nombre}(+{pais.phone_code})
                                </MenuItem>

                            )
                        })
                    }
                </Select>
            </FormControl>
        </>
    )
}

export default WhatsappSelect
